/**
 * Resolves the correct API base URL at runtime based on the current hostname.
 *
 * Cloud Run's postinstall always runs `npm run build` in production mode,
 * so VUE_APP_API_BASE is baked in as the production value regardless of which
 * frontend environment we're deploying. We detect the environment from the
 * browser hostname instead.
 */
export function resolveApiBase(): string {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'beta.myuser.ai') return 'https://api-beta.myuser.ai';
    if (host === 'dev.myuser.ai') return 'https://api-dev.myuser.ai';
    if (host === 'localhost')
      return process.env.VUE_APP_API_BASE || 'http://localhost:8081';
  }
  return process.env.VUE_APP_API_BASE || 'https://api.myuser.ai';
}

export const API_BASE = resolveApiBase();
